import { OrderedMap } from "immutable";

export const getSelectionRange = () => {
  const selection = window.getSelection();
  if (selection.rangeCount === 0) return null;
  return selection.getRangeAt(0);
};

export const getSelectionCoords = (selectionRange) => {
  const editorBounds = document
    .getElementById("editor-container")
    .getBoundingClientRect();
  const rangeBounds = selectionRange.getBoundingClientRect();
  const rangeWidth = rangeBounds.right - rangeBounds.left;
  // 107px is width of inline toolbar
  const offsetLeft =
    rangeBounds.left - editorBounds.left + rangeWidth / 2 - 107 / 2;
  // 42px is height of inline toolbar
  const offsetTop = rangeBounds.top - editorBounds.top - 42;
  return { offsetLeft, offsetTop };
};

export const blockMapBuid = {
  createFromArray: function (blocks) {
    return OrderedMap(blocks.map((block) => [block.getKey(), block]));
  },
};

export const blockTableTools = {
  blockFindInTables: (blockKey = "", tables = {}) => {
    let result = {};
    Object.entries(tables).forEach(([tableKey, table]) => {
      table.rows.forEach((row, rowIndex) => {
        row.forEach((block, blockIndex) => {
          if (blockKey === block.key) {
            result = {
              table: tableKey,
              row: rowIndex,
              height: table.heights[rowIndex],
            };
          }
        });
      });
    });
    return result;
  },

  blockTablesBuild: (blocksList, editorWidth, columnWidth) => {
    let prevBlockType = "";
    let blocksWidth = 0;
    let rowIndex = 0;
    let tables = {};
    let tableKey = "";

    blocksList.forEach((block) => {
      let { width, height } = block.getData().toJS();
      if (!width) width = columnWidth;
      width += 32;
      let type = block.getType();
      let key = block.getKey();

      if (prevBlockType !== type) {
        blocksWidth = 0;
        if (type === "table") {
          tableKey = key;
          tables[tableKey] = {
            rows: [[]],
            heights: [[]],
          };

          rowIndex = 0;
        }
      }

      if (type === "table") {
        blocksWidth += width;
        if (blocksWidth >= editorWidth - 1) {
          rowIndex++;
          blocksWidth = width;
          tables[tableKey].rows[rowIndex] = [];
          tables[tableKey].heights[rowIndex] = [];
        }

        if (
          !tables[tableKey].heights[rowIndex] ||
          height > tables[tableKey].heights[rowIndex]
        )
          tables[tableKey].heights[rowIndex] = height;

        tables[tableKey].rows[rowIndex].push({ key, width, height });
      }

      prevBlockType = type;
    });

    return tables;
  },
};

export const tableHandler = {};
